module.exports = __webpack_public_path__ + "static/cloud-6a5261a26ec0aa78b9cf9758c38c16bf.png";